require('./bulkTransferInfo.scss')

module.exports = {
  template: require('./bulkTransferInfo.pug')()
  controller: require('./bulkTransferInfo.ctrl')
  bindings:
    bulkTransfer: '<'
}
